// extracted by mini-css-extract-plugin
export default {"content":"index_content_ej0nY","other":"index_other_3T2-p","rules":"index_rules_HHA4d"};